import { useMemo } from 'react'

export default function useDataTransform(props, data) {
  return useMemo(
    () =>
      data?.map(item => ({
        id: item.id,
        text: `${item.name} (${
          item.insurance_code
            ? `${item.insurance_code.code} - ${item.insurance_code.title}`
            : 'No CDT code'
        })`,
        ...item,
      })),
    [data]
  )
}
